import { FilteredDepartureDatePackages } from 'types/typescript'
import {
  GetCurrentPackageFilteredDepartureDates
} from './pricerDepartureDate.types'

export const getCurrentPackageFilteredDepartureDates: GetCurrentPackageFilteredDepartureDates = (packageElements = []) => {
  const filteredDepartureDate = packageElements.reduce((acc: Writeable<FilteredDepartureDatePackages>, packageElement) => {
    const key = packageElement.checkin
    if ((!acc[key] || acc[key].price > packageElement.price)) {
      acc[key] = {
        checkin: packageElement.checkin,
        hasPrice: packageElement.hasPrice,
        msrp: packageElement.msrp,
        price: packageElement.price,
        stock: (
          (!acc[key] || (acc[key] && packageElement.isAvailable))
            ? packageElement.isAvailable
            /*
              Here it was acc[key].isAvailable which can never exists since we arent assigning it,
              there is maybe a bug behind this. Updated to undefined since the logic should not change
              during the typescript migration.
            */
            : undefined
        )
      }
    }
    return acc
  }, {})

  return (
    Object
      .values(filteredDepartureDate)
      .sort((previousCheckin, nextCheckin) => (
        (previousCheckin.checkin > nextCheckin.checkin)
          ? 1
          : previousCheckin.checkin < nextCheckin.checkin ? -1 : 0
      ))
  )
}
